(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("gl-matrix"), require("resize-observer-polyfill"));
	else if(typeof define === 'function' && define.amd)
		define("sdf-2d", ["gl-matrix", "resize-observer-polyfill"], factory);
	else if(typeof exports === 'object')
		exports["sdf-2d"] = factory(require("gl-matrix"), require("resize-observer-polyfill"));
	else
		root["sdf-2d"] = factory(root["gl-matrix"], root["resize-observer-polyfill"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__45__) {
return 